let cms = [
  {
    path: '/cmsLogin',
    name: 'cmsLogin',
    component: () => import('@/pages/cms/cmsLogin')
  },
  {
    path: '/cmsNav',
    name: 'cmsNav',
    // redirect: '/home',
    component: () => import('@/pages/cms/cmsNav'),
    children:[
      // {
      //   path: '/NavManagement',
      //   name: 'NavManagement',
      //   component: () => import('@/pages/cms/NavManagement')
      // },
      {
        path: '/articleManagement',
        name: 'articleManagement',
        component: () => import('@/pages/cms/articleManagement')
      },
    ]
  }
]
export default cms



// WEBPACK FOOTER //
// ./src/router/module/CMS.js